<template>
  <main class="content__page">
    <section class="entry format-standard">
      <div class="content__page-header">
        <h2>
          <i class="fa fa-envelope" aria-hidden="true"></i>
          {{ $t('subscription.title') }}
        </h2>
      </div>

      <el-form ref="subscriptionForm" :model="form" :rules="rules" label-position="top" class="subscription-form">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item :label="$t('form_labels.first_name')" prop="first_name">
              <el-input v-model="form.first_name" :placeholder="$t('form_labels.first_name_placeholder')" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('form_labels.last_name')" prop="last_name">
              <el-input v-model="form.last_name" :placeholder="$t('form_labels.last_name_placeholder')" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item :label="$t('form_labels.email')" prop="email">
          <el-input v-model="form.email" :placeholder="$t('form_labels.email_placeholder')" />
        </el-form-item>

        <el-form-item :label="$t('form_labels.frequency')" prop="frequency">
          <el-radio-group v-model="form.frequency">
            <el-radio label="daily">{{ $t('subscription.daily') }}</el-radio>
            <el-radio label="weekly">{{ $t('subscription.weekly') }}</el-radio>
            <el-radio label="monthly">{{ $t('subscription.monthly') }}</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item :label="$t('form_labels.categories')" prop="categories">
          <el-select v-model="form.categories" multiple :placeholder="$t('form_labels.select_categories')">
            <el-option v-for="category in availableCategories" :key="category.id" :label="category.name" :value="category.id" />
          </el-select>
        </el-form-item>

        <div class="form-actions">
          <!-- <el-button @click="router.push({ name: 'HomePage' })">{{ $t('buttons.cancel') }}</el-button> -->
          <el-button type="secondary" @click="validateAndSubmit">{{ $t('subscription.subscribe') }}</el-button>
        </div>
      </el-form>
    </section>
  </main>
</template>

<script>
import { ref, reactive, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { useI18n } from "vue-i18n";
import { ElNotification } from "element-plus";
import { CREATE_NEWSLETTER_SUBSCRIPTION } from "@/graphql/newsletter-subscriptions";
import { GET_VISIBLE_CATEGORIES } from "@/graphql/categories";
import apolloClient from "@/services/apollo-client";

export default {
  name: 'MobileSubscribePage',
  setup() {
    const router = useRouter();
    const { t } = useI18n();
    const subscriptionForm = ref(null);
    const availableCategories = ref([]);

    const form = reactive({
      first_name: "",
      last_name: "",
      email: "",
      frequency: "weekly",
      categories: []
    });

    const rules = reactive({
      first_name: [
        { required: true, message: t("form_rules.first_name_required"), trigger: "blur" }
      ],
      last_name: [
        { required: true, message: t("form_rules.last_name_required"), trigger: "blur" }
      ],
      email: [
        { required: true, message: t("form_rules.email_required"), trigger: "blur" },
        { type: "email", message: t("form_rules.email_invalid"), trigger: ["blur", "change"] }
      ],
      frequency: [
        { required: true, message: t("form_rules.frequency_required"), trigger: "change" }
      ],
      categories: [
        { required: true, message: t("form_rules.categories_required"), trigger: "change" }
      ]
    });

    const fetchCategories = async () => {
      try {
        const { data } = await apolloClient.query({ query: GET_VISIBLE_CATEGORIES });
        availableCategories.value = data.visibleCategories;
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };

    const validateAndSubmit = () => {
      subscriptionForm.value.validate(async (valid) => {
        if (!valid) {
          return;
        }

        try {
          const { data } = await apolloClient.mutate({
            mutation: CREATE_NEWSLETTER_SUBSCRIPTION,
            variables: { 
              input: { 
                first_name: form.first_name,
                last_name: form.last_name,
                email: form.email, 
                frequency: form.frequency, 
                categories: form.categories
              }
            }
          });

          if (data?.createNewsletterSubscription?.success) {
            ElNotification({
              title: t("notifications.success.title"),
              message: t("notifications.subscriptions.success"),
              type: "success"
            });
            router.push({ name: 'HomePage' });
          } else {
            throw new Error(t("notifications.subscriptions.failed"));
          }
        } catch (error) {
          console.error("Subscription error:", error);
          ElNotification({
            title: t("notifications.error.title"),
            message: t("notifications.subscriptions.error"),
            type: "error"
          });
        }
      });
    };

    onMounted(fetchCategories);

    return {
      router,
      subscriptionForm,
      form,
      rules,
      availableCategories,
      validateAndSubmit
    };
  }
};
</script>

<style scoped>
::v-deep(.centered-container) {
  display: block !important;
}

.content__page {
  max-width: 600px;
  margin:0px auto;
  padding:0px;
}

.entry {
  width: 100%;
}

.form-actions {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}

</style> 